<template>
	<div>
	  <mu-appbar style="width: 100%;" color="#2196f3" >  
			 <mu-button icon slot="left"  @click="goback">
               <mu-icon  value="arrow_back"></mu-icon>
         </mu-button>
         <mu-button icon slot="right"  @click="refresh">
               <mu-icon  value="refresh"></mu-icon>
         </mu-button>
			充值记录
      </mu-appbar>

      <mu-paper>
        <div v-for="item in datalist"  :key="item.time" style="padding: 10px;">
           <div  class="hbox hlayout" >
              <div>时间:{{item.time}}</div>
              <div>金额:{{item.value}}</div>
           </div>
           <div class="hbox hlayout">
                <div>类型:{{item.desc}}</div>
              <div>状态:{{item.state}}</div>
           </div>
       
           <div style="height:1px;width:100%;background:#cccccc;"></div>
        </div>
      </mu-paper>
      
      <mu-paper v-if="false">
      	 <mu-data-table :columns="columns" :data="datalist" >
      	 	<template slot-scope="scope">

               <td >{{scope.row.value}}</td>
               <td >{{scope.row.time}}</td>
               <td >{{scope.row.type}}</td>
               <td >{{scope.row.state}}</td>
        
      	 	</template>
      	 </mu-data-table>
      </mu-paper>
    </div>

</template>
<script type="text/javascript">
  import Api from '@/api'
	export default {
     
     created(){
       this.refresh();
     },
		 data(){
           return {
           	columns:[

           	    {title:"金额",name:'value',width:0.25*window.innerWidth},
           	    {title:"时间",name:'time',width:0.25*window.innerWidth},
           	    {title:"方式",name:"type",width:0.25*window.innerWidth},
                {title:"状态",name:'state',width:0.25*window.innerWidth}
           	],
           	datalist:[
           	 
           	]
           }
		  },

         methods:{
          refresh()
          {
                Api.getRechargeRecord().then((res)=>{
          this.datalist=res.data;
        })
          },
         	goback(){
         		this.$router.go(-1);
         	}
         }
	}
</script>
<style scoped>
  
 .mu-table  td {
    padding: 0;
    text-align: center;
    width:25%;
  }
  .mu-table th {
     padding: 0;
    text-align: center;
  }
  .hlayout {
    justify-content: space-between;
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/RechargeRecord.vue